import { LogoMark } from '@/components/logo-mark';
import FadeIn from '@/components/motion/fade-in';
import { DURATION, EASE, useReducedMotion } from '@/lib/motion-presets';
import { UserIcon } from 'lucide-react';
import { motion } from 'motion/react';

type AuthHeroProps = {
	nickname: string;
	success?: boolean;
};

export default function AuthHero({ nickname, success }: AuthHeroProps) {
	const reducedMotion = useReducedMotion();

	return (
		<FadeIn className='flex flex-col items-center gap-4'>
			<motion.div
				className='text-[var(--auth-white)]'
				style={{ width: 96, height: 96 }}
				animate={success && !reducedMotion ? { scale: [1, 0.98, 1.02, 1] } : { scale: 1 }}
				transition={{ duration: DURATION * 3, ease: EASE }}
			>
				<LogoMark className='h-full w-full' />
			</motion.div>
			<div className='flex flex-col items-center gap-2'>
				<p className='text-xs uppercase tracking-widest text-[var(--auth-red)]'>Вход в панель</p>
				<div className='flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 backdrop-blur-sm'>
					<UserIcon className='text-white/60' size={16} />
					<span className='text-sm font-medium text-[var(--auth-white)]'>{nickname}</span>
				</div>
			</div>
		</FadeIn>
	);
}
